var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(function () {
    angular.module('QMC.Holiday', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('holiday', {
            url: '/holiday',
            templateUrl: qmcBase + '/Holiday',
            controller: 'HolidayListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Holiday List');
                    }]
            }
        })
            .state('holidayDetail', {
            url: '/holiday/:id',
            templateUrl: qmcBase + '/Holiday',
            controller: 'HolidayListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Holiday Detail');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Holiday.HttpProvider = HttpProvider;
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Holiday')
        .config(['$httpProvider', QMC.Holiday.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        var HolidayService = /** @class */ (function (_super) {
            __extends(HolidayService, _super);
            function HolidayService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Holiday';
                return _this;
            }
            HolidayService.prototype.getHolidayWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            HolidayService.prototype.getHoliday = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + "/" + id, {}, function (data) {
                    return data;
                });
            };
            HolidayService.prototype.getHolidayInfo = function (date) {
                if (date)
                    date = moment(date).startOf('day').toDate();
                return _super.prototype.getItem.call(this, this.modulePath + "/info", { date: date }, function (data) {
                    return data;
                });
            };
            HolidayService.prototype.getHolidayLock = function () {
                return _super.prototype.getItem.call(this, this.modulePath + "/Lock", {}, function (data) {
                    return data;
                });
            };
            HolidayService.prototype.getHolidayList = function (dateFrom, dateTo) {
                return _super.prototype.get.call(this, this.modulePath, { dateFrom: dateFrom, dateTo: dateTo }, function (data) {
                    return data;
                });
            };
            HolidayService.prototype.postHoliday = function (data) {
                return _super.prototype.post.call(this, this.modulePath, data).then(function (data) {
                    return data;
                });
            };
            HolidayService.prototype.putHoliday = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + "/" + id, data).then(function (data) {
                    return data;
                });
            };
            HolidayService.prototype.deleteHoliday = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + "/" + id).then(function (data) {
                    return data;
                });
            };
            HolidayService.prototype.calculateDayValues = function (dateFrom, dateTo, referenceId) {
                return _super.prototype.post.call(this, "/Roster/Service/CalculateDayValues", { dateFrom: dateFrom, dateTo: dateTo, referenceId: referenceId }).then(function (data) {
                    return data;
                });
            };
            HolidayService.prototype.checkForWarningsAndErrors = function (data) {
                return _super.prototype.post.call(this, this.modulePath + "/WarningsAndErrors", data).then(function (data) {
                    return data;
                });
            };
            HolidayService = __decorate([
                QMC.Service('QMC.Holiday', 'HolidayService'),
                QMC.Inject('$http', '$q')
            ], HolidayService);
            return HolidayService;
        }(QMC.Common.BaseService));
        Holiday.HolidayService = HolidayService;
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        /**
         * Holiday UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.showMonthFilter = true;
                /**
                 * Holiday list table
                 * @memberOf UserInterface
                 */
                _this.listTable = {
                    "config": {
                        "defaultSort": "dateFrom",
                        "sortReverse": "true",
                    },
                    "filter": {
                        model: null
                    },
                    "table": {
                        "Farbe": {
                            "label": "color",
                            "dType": "Color"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                        "Genehmigungsstatus": {
                            "label": "approved",
                            "dType": "string",
                            "lngTag": "20020007"
                        },
                        "Länge": {
                            "label": "holidayDuration",
                            "dType": "string",
                            "lngTag": "20020032"
                        },
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Art": {
                            "label": "serviceType",
                            "dType": "string",
                            "lngTag": "20020008"
                        },
                        "Aktionen": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "editHoliday",
                                "openModal": "true",
                                "targetModal": "#edit-form",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "events": {
                                    "hide": "allowEdit"
                                },
                            },
                            {
                                "icon": "qm-icon-pencil blue",
                                "click": "editHoliday",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-form",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "events": {
                                    "hide": "!allowEdit"
                                },
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHoliday",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "events": {
                                    "hide": "!allowDelete"
                                },
                                "permission": "delete"
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!viewComment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }
                        ]
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-palm_tree"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "serviceType",
                                "dType": "string"
                            },
                            {
                                "label": "holidayDuration",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "dType": "Date"
                            },
                            {
                                "prefix": "Genehmigung: ",
                                "label": "approved",
                                "dType": "string"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-pencil blue",
                                "click": "editHoliday",
                                "openModal": "true",
                                "targetModal": "#edit-form",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!allowEdit"
                                },
                            },
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "editHoliday",
                                "openModal": "true",
                                "targetModal": "#edit-form",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "events": {
                                    "hide": "allowEdit"
                                },
                            },
                            {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHoliday",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!allowDelete"
                                },
                            },
                            {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!viewComment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }
                        ]
                    },
                    "data": null,
                };
                _this.holidayForm = {
                    form: [
                        {
                            placeholder: "Urlaubsart auswählen",
                            label: "Urlaubsart",
                            type: "Select2",
                            required: true,
                            model: "isSpecialHoliday",
                            lngTag: 20020008,
                            dataSource: "getHolidayCategoryList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                updateDataSource: "holidayTypeId",
                            },
                            validate: {
                                message: "Bitte die Urlaubsart auswählen.",
                                messageTag: 21003019
                            },
                        },
                        {
                            placeholder: "Urlaubsunterart auswählen",
                            label: "Urlaubsart",
                            type: "Select2",
                            required: false,
                            model: "holidayTypeId",
                            lngTag: 20020020,
                            dataSource: "getHolidayTypeList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            validate: {
                                message: "Bitte die Urlaubsunterart auswählen.",
                                messageTag: 21003021
                            },
                            events: {
                                hideExpression: "qmForm.isSpecialHoliday"
                            },
                            id: "holidayTypeId",
                            wvId: '827662a9-b386-4546-9f8e-cc52e896c336',
                            wvListData: 'wvList.holidayTypeWvList',
                            wvValueType: 'color'
                        },
                        {
                            placeholder: "Urlaubsunterart auswählen",
                            label: "Urlaubsart",
                            type: "Select2",
                            required: false,
                            model: "holidayTypeId",
                            lngTag: 20020020,
                            dataSource: "getSpecialHolidayTypeList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            validate: {
                                message: "Bitte die Urlaubsunterart auswählen.",
                                messageTag: 21003021
                            },
                            events: {
                                hideExpression: "!qmForm.isSpecialHoliday"
                            },
                            wvId: '4dd3f89a-2cdd-49fb-8d11-0be9f8ea3431',
                            wvListData: 'wvList.specialHolidayTypeWvList',
                            wvValueType: 'color'
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            lngTag: 20020007,
                            events: {
                                hideExpression: "!qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            lngTag: 20020007,
                            disabled: true,
                            events: {
                                hideExpression: "qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            type: "hr"
                        },
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true
                            }
                        },
                        {
                            label: "Anzahl Tage",
                            type: "CheckboxInline",
                            lngTag: 20020026,
                            model: "isManualDays",
                            id: "isManualDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: true,
                            id: "amountOfDaysDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "qmForm.isManualDays"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: false,
                            id: "amountOfDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "!qmForm.isManualDays"
                            }
                        },
                        {
                            label: "Anzahl Stunden",
                            type: "CheckboxInline",
                            lngTag: 20020027,
                            model: "isManualHours",
                            id: "isManualHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: true,
                            id: "amountOfHoursDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmForm.isManualHours"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: false,
                            id: "amountOfHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "!qmForm.isManualHours"
                            }
                        },
                        {
                            label: "Dienste anrechnen",
                            type: "CheckboxInline",
                            lngTag: 20020024,
                            model: "creditWorkAsHoliday",
                            id: "creditWorkAsHoliday",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "qm-icon-painters_palette"
                            },
                            disabled: true
                        },
                        {
                            placeholder: "Bemerkung eintragen...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        },
                    ],
                    actions: {
                        put: "putHoliday",
                        post: "addHoliday",
                        delete: "deleteHoliday"
                    }
                };
                return _this;
            }
            return UserInterface;
        }(QMC.Common.UserInterface));
        Holiday.UserInterface = UserInterface;
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        var HolidayListController = /** @class */ (function () {
            /**
             * Creates an instance of HolidayListController.
             * @param {HolidayService} holidayService
             * @param {any} $qui
             * @param {ng.IScope} $scope
             * @param {any} $stateParams
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {*} userService
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberof HolidayListController
             */
            function HolidayListController(holidayService, $qui, $scope, $sce, $stateParams, $state, lng, userService, permissionService, $location) {
                var _this = this;
                this.holidayService = holidayService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$sce = $sce;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.permissionService = permissionService;
                this.$location = $location;
                this.ui = new Holiday.UserInterface();
                this.allowTableExport = false;
                this.storageName = 'Holiday_' + $('#session').data().userId;
                this.initModal = 'init';
                this.validation = {
                    isLoading: false,
                    errors: [],
                    warnings: [],
                    hours: Number,
                    days: Number
                };
                this.permissions = { standard: undefined, special: undefined, approved: undefined, document: undefined, documentSpecial: undefined };
                this.formDisabled = true;
                this.callbacks = { onNew: function () { return _this.getData(); }, onEdit: function () { return _this.getData(); }, onDelete: function () { return _this.getData(); } };
                this.approvementMap = [];
                this.data = [];
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                this.contingentDate = new Date();
                this.filter = {
                    dateFrom: moment().startOf('year').toDate(),
                    dateTo: moment().endOf('year').toDate(),
                    approvement: []
                };
                if (document.getElementById("permissions").getAttribute("holiday").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                this.userService.getUserSettings(["FLS.SHOWMONTHFILTER"]).then(function (data) {
                    _this.showMonthFilter = data[0].value.toLowerCase() === "true";
                    if (_this.showMonthFilter)
                        _this.showMonthFilter = "year";
                });
                this.promptOptions = {
                    title: "Urlaubsantrag",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.getWv();
                this.permissionService.getPermissionsByObjectTypes([411003, 411005, 120024, 411016, 411017]).then(function (data) {
                    _this.permissions.standard = data[0];
                    _this.allowTableExport = data[0].print;
                    _this.permissions.special = data[1];
                    _this.new = _this.permissions.special.new || _this.permissions.standard.new;
                    _this.modify = _this.permissions.special.modify || _this.permissions.standard.modify || _this.new;
                    _this.delete = _this.permissions.special.delete || _this.permissions.standard.delete || _this.new;
                    _this.permissions.approved = data[2];
                    _this.permissions.document = data[3];
                    _this.permissions.documentSpecial = data[4];
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                        else {
                            _this.getHolidayInfo();
                        }
                    });
                    _this.init();
                    if (_this.$stateParams.id) {
                        _this.editHoliday({ objectId: _this.$stateParams.id });
                    }
                });
                this.ui.listTable.filter.model = this.tableFilter;
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            /**
             * Init the filter an  the form, with default values
             *
             * @private
             *
             * @memberof HolidayListController
             */
            HolidayListController.prototype.init = function () {
                var _this = this;
                this.$scope.$watch('vm.filter.dateFrom', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.getData();
                });
                this.$scope.$watch('vm.filter.dateTo', function (newValue, oldValue) {
                    if (newValue === oldValue || _this.showMonthFilter)
                        return;
                    _this.getData();
                });
                this.$scope.$watch('vm.filter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    localStorage.setItem(_this.storageName, JSON.stringify(_this.filter));
                    _this.ui.listTable.data = _this.getFilteredData(_this.data);
                    _this.$qui.functionWaiter("ui.createTable", _this);
                }, true);
                this.$scope.$watch('vm.contingentDate', function (newValue, oldValue) {
                    if (!newValue || !oldValue || newValue === oldValue)
                        return;
                    _this.getHolidayInfo();
                });
            };
            /**
             * edit an existing holiday
             *
             * @private
             * @param {IHolidayListItem} form
             *
             * @memberof HolidayListController
             */
            HolidayListController.prototype.editHoliday = function (form) {
                this.calls.edit(form.objectId);
            };
            HolidayListController.prototype.getData = function () {
                this.getHolidayList();
                this.getHolidayInfo();
            };
            HolidayListController.prototype.allowDataSetEdit = function (data) {
                return (data.approvedId === QMC.Common.Constants.APPROVAL_PENDING_ID || this.permissions.approved.openFile) && data.permissions.modify;
            };
            HolidayListController.prototype.getFilteredData = function (data) {
                var _this = this;
                var temp = data;
                if (this.filter.approvement.length)
                    temp = temp.filter(function (x) { return _this.filter.approvement.some(function (y) { return y === x.approvedId; }); });
                return temp;
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            /**
             * get the holiday info
             *
             * @private
             *
             * @memberof HolidayListController
             */
            HolidayListController.prototype.getHolidayInfo = function () {
                var _this = this;
                this.infoLoad = true;
                var date = moment(this.contingentDate).endOf('day').toDate();
                //if (date.getFullYear() !== this.filter.dateFrom.getFullYear())
                //    date = moment(date).year(this.filter.dateFrom.getFullYear()).endOf('year').toDate();
                this.holidayService.getHolidayInfo(date).then(function (data) {
                    _this.infoLoad = false;
                    if (!data) {
                        _this.holidayInfo = undefined;
                        return;
                    }
                    data.contingentString = '';
                    if (data.calculatedFrom && data.calculatedUntil)
                        data.contingentString = moment(data.calculatedFrom).format('DD.MM.yyyy') + " - " + moment(data.calculatedUntil).format('DD.MM.yyyy');
                    if (!data.calculatedFrom && data.calculatedUntil)
                        data.contingentString = _this.lng.translate(20000048, 'bis') + " " + moment(data.calculatedUntil).format('DD.MM.yyyy');
                    if (data.calculatedFrom && !data.calculatedUntil)
                        data.contingentString = _this.lng.translate(20000067, 'von') + " " + moment(data.calculatedFrom).format('DD.MM.yyyy');
                    _this.holidayInfo = data;
                });
            };
            /**
             * get a list of all holidays, by date range
             *
             * @private
             *
             * @memberof HolidayListController
             */
            HolidayListController.prototype.getHolidayList = function () {
                var _this = this;
                this.listLoad = true;
                var dateFrom = moment(this.filter.dateFrom).add(3, 'hours').toDate();
                var dateTo = moment(this.filter.dateTo).add(-3, 'hours').toDate();
                this.holidayService.getHolidayList(dateFrom, dateTo).then(function (data) {
                    data = data.map(function (obj) {
                        obj.allowEdit = _this.allowDataSetEdit(obj);
                        obj.allowDelete = (obj.approvedId === QMC.Common.Constants.APPROVAL_PENDING_ID || _this.permissions.approved.openFile) && obj.permissions.delete;
                        obj.viewComment = obj.approvedComment && obj.approvedComment !== "";
                        return obj;
                    });
                    _this.data = data;
                    _this.ui.listTable.data = _this.getFilteredData(data);
                    _this.listLoad = false;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                });
            };
            /**
            * show a modal dialog displaying the comment for a holiday entry
            *
            * @private
            * @param {IHoliday} data
            *
            * @memberof HolidayListController
            */
            HolidayListController.prototype.toggleCommentModal = function (data) {
                var _this = this;
                this.holidayService.getHoliday(data.objectId).then(function (data) {
                    _this.currentHoliday = data;
                    _this.currentHoliday.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    if (_this.currentHoliday.dateFrom !== (null || undefined))
                        _this.currentHoliday.dateTo = _this.$qui.createDateFromString(data.dateTo);
                });
                $('#holidayComment').modal('toggle');
            };
            HolidayListController.prototype.deleteHoliday = function (item) {
                this.calls.delete(item);
            };
            HolidayListController.prototype.getWv = function () {
                var _this = this;
                this.holidayService.getHolidayWv().then(function (data) {
                    // Create Filter selection
                    _this.approvementMap = data.approvementWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    if (localStorage.getItem(_this.storageName))
                        _this.filter.approvement = JSON.parse(localStorage.getItem(_this.storageName)).approvement;
                });
            };
            HolidayListController = __decorate([
                QMC.Controller('QMC.Holiday', 'HolidayListController'),
                QMC.Inject('HolidayService', '$qui', '$scope', '$sce', '$stateParams', '$state', 'QmcLanguageService', 'UserService', 'QmcPermissionService', '$location')
            ], HolidayListController);
            return HolidayListController;
        }());
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Holiday;
    (function (Holiday) {
        var HolidayFormDirective = /** @class */ (function () {
            function HolidayFormDirective(scope, holidayService, $qui, lng, rosterService) {
                var _this = this;
                this.scope = scope;
                this.holidayService = holidayService;
                this.$qui = $qui;
                this.lng = lng;
                this.rosterService = rosterService;
                this.ui = new Holiday.UserInterface();
                this.calcedValues = { days: 0, hours: 0 };
                this.validation = {
                    isLoading: false,
                    errors: [],
                    warnings: []
                };
                this.pauseWatchers = false;
                this.id = '_' + Math.random().toString(36).substr(2, 9);
                this.promptOptions = {
                    title: "Urlaubsantrag",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                    itemText: ''
                };
                this.$postLink = function () {
                    _this.calls = {
                        new: function (form) {
                            _this.initForm();
                            _this.formState = 'new';
                            _this.lastValidation = undefined;
                            _this.validation.errors = [];
                            _this.validation.warnings = [];
                            if (form !== 'init') {
                                _this.form = form !== null && form !== void 0 ? form : _this.form;
                                if (_this.wvList && _this.wvList.holidayTypeWvList.length === 2)
                                    _this.form.holidayTypeId = _this.wvList.holidayTypeWvList[1].objectId;
                                _this.calls.open();
                                _this.ui.createForm();
                            }
                            _this.disabledIntern = !_this.permissions.standard.new;
                        },
                        edit: function (form, start, end) {
                            var _a, _b;
                            _this.formState = 'edit';
                            _this.lastValidation = undefined;
                            _this.validation.errors = [];
                            _this.validation.warnings = [];
                            if (typeof form === 'string') {
                                _this.loadHoliday(form, start, end);
                            }
                            else {
                                _this.form = form !== null && form !== void 0 ? form : _this.form;
                                _this.pauseWatchers = true;
                                _this.formatForm();
                                setTimeout(function () { _this.pauseWatchers = false; _this.validate(); }, 50);
                                _this.disabledIntern = !((((_a = _this.form) === null || _a === void 0 ? void 0 : _a.approvedId) === QMC.Common.Constants.APPROVAL_PENDING_ID || _this.permissions.approved.openFile) && ((_b = _this.form) === null || _b === void 0 ? void 0 : _b.permissions.modify));
                                if (start)
                                    _this.form.dateFrom = start;
                                if (end)
                                    _this.form.dateTo = end;
                                _this.ui.createForm();
                            }
                            _this.calls.open();
                        },
                        delete: function (form) { _this.deleteHoliday(form !== null && form !== void 0 ? form : _this.form); },
                        open: function () {
                            $('#' + _this.id).modal('show');
                            _this.$qui.waitForEl('#standardTabButton', function () {
                                $('#standardTabButton').click();
                            });
                        },
                        close: function () { $('#' + _this.id).modal('hide'); }
                    };
                };
                this.$onDestroy = function () {
                    $('#' + _this.id).remove();
                };
                this.init();
                this.events();
            }
            HolidayFormDirective.prototype.getModalCaption = function () {
                var _a;
                var result = this.lng.translate(20020011, 'Urlaubsantrag');
                if ((_a = this.reference) === null || _a === void 0 ? void 0 : _a.name)
                    result = result + " (" + this.reference.name + ")";
                return result;
            };
            HolidayFormDirective.prototype.formatForm = function () {
                if (this.form) {
                    this.form.approved = this.getApprovementWvItem(this.form.approvedId);
                    this.form.isManualDays = this.form.accountingTypeFlag === 0;
                    this.form.isManualHours = this.form.accountingTypeFlag === 1;
                    this.form.creditWorkAsHoliday = this.form.accountingTypeFlag === 2;
                    this.form.permissionApproved = this.permissions.approved.openFile;
                }
            };
            HolidayFormDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.form.holidayTypeId', function (newValue, oldValue) {
                    var _a;
                    if (_this.pauseWatchers || newValue === oldValue || !((_a = _this.form) === null || _a === void 0 ? void 0 : _a.holidayTypeId) || _this.form.holidayTypeId === QMC.Common.Constants.GUID_EMPTY)
                        return;
                    if (!_this.wvList || !_this.wvList.holidayTypeWvList)
                        return;
                    var wvs = _this.wvList.holidayTypeWvList;
                    if (_this.form.isSpecialHoliday && _this.wvList.specialHolidayTypeWvList)
                        wvs = _this.wvList.specialHolidayTypeWvList;
                    //get integervalue
                    for (var _i = 0, wvs_1 = wvs; _i < wvs_1.length; _i++) {
                        var item = wvs_1[_i];
                        if (_this.form.holidayTypeId === item.objectId) {
                            // convert argb color in wv to html color
                            _this.form.color = '#' + ('000000' + (item.value & 0xFFFFFF).toString(16)).slice(-6);
                        }
                    }
                });
                this.scope.$watch('vm.form.isManualDays', function (newValue) {
                    if (_this.pauseWatchers || !newValue || !_this.form)
                        return;
                    _this.form.isManualHours = false;
                    _this.form.creditWorkAsHoliday = false;
                    _this.form.accountingTypeFlag = 0;
                });
                this.scope.$watch('vm.form.isManualHours', function (newValue) {
                    if (_this.pauseWatchers || !newValue || !_this.form)
                        return;
                    _this.form.isManualDays = false;
                    _this.form.creditWorkAsHoliday = false;
                    _this.form.accountingTypeFlag = 1;
                });
                this.scope.$watch('vm.form.creditWorkAsHoliday', function (newValue) {
                    if (_this.pauseWatchers || !newValue || !_this.form)
                        return;
                    _this.form.isManualDays = false;
                    _this.form.isManualHours = false;
                    _this.form.accountingTypeFlag = 2;
                });
                this.scope.$watch('vm.form.dateFrom', function (newValue, oldValue) {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    _this.getCalcDayValues();
                });
                this.scope.$watch('vm.form.dateTo', function (newValue, oldValue) {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    _this.getCalcDayValues();
                });
                this.scope.$watch('vm.form', function (newValue, oldValue) {
                    if (!newValue || JSON.stringify(newValue) === JSON.stringify(oldValue))
                        return;
                    if (!_this.pauseWatchers) {
                        // make sure accountingType checkboxes work as Radio Boxes and set the flag
                        if (!newValue.isManualDays && !newValue.isManualHours && !newValue.creditWorkAsHoliday) { // there must always be one
                            if (oldValue) {
                                _this.form.isManualDays = oldValue.isManualDays;
                                _this.form.isManualHours = oldValue.isManualHours;
                                _this.form.creditWorkAsHoliday = oldValue.creditWorkAsHoliday;
                            }
                            else
                                _this.form.isManualDays = true;
                        }
                        if (_this.form.isManualDays) {
                            _this.form.accountingTypeFlag = 0;
                            _this.form.amountOfHours = 0;
                            if (!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.isManualDays))
                                _this.form.amountOfDays = _this.calcedValues.days;
                        }
                        if (_this.form.isManualHours) {
                            _this.form.accountingTypeFlag = 1;
                            _this.form.amountOfDays = 0;
                            if (!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.isManualHours))
                                _this.form.amountOfHours = _this.calcedValues.hours;
                        }
                        if (_this.form.creditWorkAsHoliday) {
                            _this.form.amountOfDays = 0;
                            _this.form.amountOfHours = 0;
                            _this.form.accountingTypeFlag = 2;
                        }
                        // validate
                        _this.validate();
                    }
                    // set approved string
                    _this.form.approved = _this.getApprovementWvItem(_this.form.approvedId);
                }, true);
            };
            ;
            HolidayFormDirective.prototype.init = function () {
                var _this = this;
                this.holidayService.getHolidayLock().then(function (lockDate) {
                    _this.lockDate = _this.$qui.createDateFromString(lockDate);
                });
                this.holidayService.getHolidayWv().then(function (data) {
                    _this.wvList = data;
                    _this.approvementList = _this.ui.select(data.approvementWvList, { value: 'objectId', text: 'name' });
                });
            };
            HolidayFormDirective.prototype.initForm = function () {
                var _a, _b, _c, _d;
                this.form = {
                    comment: "",
                    dateFrom: moment().startOf('day').toDate(),
                    dateTo: moment().endOf('day').toDate(),
                    holidayTypeId: null,
                    isSpecialHoliday: false,
                    color: '#0000FF',
                    amountOfDays: 1,
                    amountOfHours: 0,
                    accountingTypeFlag: 0,
                    isManualDays: true,
                    isManualHours: false,
                    creditWorkAsHoliday: false,
                    permissionApproved: (_b = (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.approved) === null || _b === void 0 ? void 0 : _b.openFile,
                    approvedId: ((_d = (_c = this.permissions) === null || _c === void 0 ? void 0 : _c.approved) === null || _d === void 0 ? void 0 : _d.openFile) ? QMC.Common.Constants.APPROVAL_APRROVED_ID : QMC.Common.Constants.APPROVAL_PENDING_ID
                };
            };
            HolidayFormDirective.prototype.getHolidayCategoryList = function () {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var result = [];
                if (((_b = (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.standard) === null || _b === void 0 ? void 0 : _b.new) || ((_d = (_c = this.permissions) === null || _c === void 0 ? void 0 : _c.standard) === null || _d === void 0 ? void 0 : _d.modify))
                    result.push({ value: false, text: this.lng.translate(20020000, "Urlaub") });
                if (((_f = (_e = this.permissions) === null || _e === void 0 ? void 0 : _e.special) === null || _f === void 0 ? void 0 : _f.new) || ((_h = (_g = this.permissions) === null || _g === void 0 ? void 0 : _g.special) === null || _h === void 0 ? void 0 : _h.modify))
                    result.push({ value: true, text: this.lng.translate(20020019, "Sonderurlaub") });
                return result;
            };
            HolidayFormDirective.prototype.getHolidayTypeList = function () {
                return this.wvList.holidayTypeWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); });
            };
            HolidayFormDirective.prototype.getSpecialHolidayTypeList = function () {
                return this.wvList.specialHolidayTypeWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); });
            };
            HolidayFormDirective.prototype.getApprovementWvList = function () {
                return this.wvList.approvementWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); });
            };
            HolidayFormDirective.prototype.getApprovementWvItem = function (approvedId) {
                var _a, _b, _c, _d;
                var result = (_b = (_a = this.wvList) === null || _a === void 0 ? void 0 : _a.approvementWvList) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item.objectId === approvedId; });
                return result ? (_d = (_c = result[0]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '' : '';
            };
            HolidayFormDirective.prototype.getCheckboxStatus = function () {
                if (this.form.isManualDays)
                    return 0;
                if (this.form.isManualHours)
                    return 1;
                if (this.form.creditWorkAsHoliday)
                    return 2;
            };
            HolidayFormDirective.prototype.getCalcDayValues = function () {
                var _this = this;
                var _a, _b;
                this.holidayService.calculateDayValues(this.form.dateFrom, this.form.dateTo, (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId).then(function (data) {
                    _this.calcedValues.days = data.calcDays;
                    _this.calcedValues.hours = 0;
                    if (_this.form.isManualDays)
                        _this.form.amountOfDays = _this.calcedValues.days;
                    if (_this.form.isManualHours)
                        _this.form.amountOfDays = _this.calcedValues.hours;
                });
            };
            HolidayFormDirective.prototype.validate = function () {
                var _this = this;
                var _a, _b;
                if (!this.form)
                    return;
                var validationForm = {
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo,
                    holidayId: this.form.objectId ? this.form.objectId : QMC.Common.Constants.GUID_EMPTY,
                    approvementTypeId: this.form.approvedId ? this.form.approvedId : QMC.Common.Constants.GUID_EMPTY,
                    isSpecialHoliday: this.form.isSpecialHoliday,
                    holidayTypeId: this.form.holidayTypeId,
                    calculationType: this.getCheckboxStatus(),
                    randomId: Math.random().toString(36).substr(2, 9),
                    dayCount: this.form.isManualDays ? this.form.amountOfDays : 0,
                    hourCount: this.form.isManualHours ? this.form.amountOfHours : 0,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId
                };
                if (this.lastValidation) {
                    var last = angular.copy(this.lastValidation);
                    var current = angular.copy(validationForm);
                    delete last.randomId;
                    delete current.randomId;
                    if (JSON.stringify(last) === JSON.stringify(current))
                        return;
                }
                this.lastValidation = validationForm;
                this.validation = {
                    warnings: [],
                    errors: [],
                    isLoading: true
                };
                var loading = 0;
                var finallyAction = function () {
                    loading++;
                    _this.validation.isLoading = loading < 1;
                };
                var catchAction = function () {
                    _this.validation.errors = [_this.lng.translate(0, 'Es konnte nicht komplett validiert werden')];
                };
                var getAction = function (data) {
                    if (_this.lastValidation.randomId === validationForm.randomId) {
                        if (data.warnings.length > 0)
                            _this.validation.warnings = _this.validation.warnings.concat(data.warnings);
                        if (data.errors.length > 0)
                            _this.validation.errors = _this.validation.errors.concat(data.errors);
                    }
                };
                this.holidayService.checkForWarningsAndErrors(validationForm).then(function (data) {
                    getAction(data);
                    if (_this.lastValidation.randomId === validationForm.randomId && _this.lockDate && validationForm.dateFrom > _this.lockDate) {
                        _this.validation.warnings.push(_this.lng.translate(20020012, "Sie können keinen Urlaubsantrag erstellen, der nach dem Sperrdatum liegt."));
                    }
                }).catch(catchAction).finally(finallyAction);
                //this.rosterService.validateNonService({
                //    entryId: this.form.objectId,
                //    referenceId: this.reference?.id ?? $('#session').data().personId,
                //    reference: this.reference?.name ?? '',
                //    dateFrom: this.form.dateFrom,
                //    dateTo: this.form.dateTo,
                //    serviceTypeId: '8bdf6a27-a881-4b4b-8abf-3bedb5156df2',
                //    serviceSubTypeId: this.form.serviceSubTypeId,
                //    randomId: Math.random().toString(36).substring(2, 11)
                //}).then((data) => getAction(data)).catch(catchAction).finally(finallyAction);
            };
            HolidayFormDirective.prototype.loadHoliday = function (id, start, end) {
                var _this = this;
                this.loading = true;
                this.holidayService.getHoliday(id).then(function (data) {
                    _this.pauseWatchers = true;
                    data.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    if (data.dateTo)
                        data.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    _this.form = data;
                    _this.formatForm();
                    _this.disabledIntern = !((data.approvedId === QMC.Common.Constants.APPROVAL_PENDING_ID || _this.permissions.approved.openFile) && data.permissions.modify);
                    if (start)
                        _this.form.dateFrom = start;
                    if (end)
                        _this.form.dateTo = end;
                    setTimeout(function () {
                        _this.pauseWatchers = false;
                        _this.loading = false;
                        _this.validate();
                    }, 50);
                    _this.ui.createForm();
                });
            };
            HolidayFormDirective.prototype.putHoliday = function (form) {
                var _this = this;
                if (this.validation.errors.length === 0 && !this.validation.isLoading) {
                    this.holidayService.putHoliday(form.id, form).then(function () {
                        var _a;
                        _this.ui.notify(_this.ui.successNote);
                        if ((_a = _this.callbacks()) === null || _a === void 0 ? void 0 : _a.onEdit)
                            _this.callbacks().onEdit(true);
                        _this.calls.close();
                    }).catch(function () {
                        var _a;
                        if ((_a = _this.callbacks()) === null || _a === void 0 ? void 0 : _a.onEdit)
                            _this.callbacks().onEdit(false);
                    });
                }
            };
            HolidayFormDirective.prototype.deleteHoliday = function (item) {
                var _this = this;
                this.promptOptions.itemText = item.caption + " (" + moment(item.dateFrom).format("DD.MM.YYYY") + " - " + moment(item.dateTo).format("DD.MM.YYYY") + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.holidayService.deleteHoliday(item.id).then(function () {
                            var _a;
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.calls.close();
                            if ((_a = _this.callbacks()) === null || _a === void 0 ? void 0 : _a.onDelete)
                                _this.callbacks().onDelete(true);
                        }).catch(function () {
                            var _a;
                            if ((_a = _this.callbacks()) === null || _a === void 0 ? void 0 : _a.onDelete)
                                _this.callbacks().onDelete(false);
                        });
                    }
                }, "#" + this.id + "-prompt");
            };
            HolidayFormDirective.prototype.addHoliday = function (form) {
                var _this = this;
                var _a, _b;
                if (this.validation.errors.length === 0 && !this.validation.isLoading) {
                    this.form.referenceId = (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId;
                    this.holidayService.postHoliday(form).then(function () {
                        var _a;
                        _this.ui.notify(_this.ui.successNote);
                        if ((_a = _this.callbacks()) === null || _a === void 0 ? void 0 : _a.onNew)
                            _this.callbacks().onNew(true);
                        _this.calls.close();
                    }).catch(function () {
                        var _a;
                        if ((_a = _this.callbacks()) === null || _a === void 0 ? void 0 : _a.onNew)
                            _this.callbacks().onNew(false);
                    });
                }
            };
            return HolidayFormDirective;
        }());
        angular.module('QMC.Holiday').component('qmHolidayForm', {
            templateUrl: './Holiday/FormDirective',
            controller: ['$scope', 'HolidayService', '$qui', 'QmcLanguageService', 'RosterService', HolidayFormDirective],
            controllerAs: 'vm',
            bindings: {
                form: '=?',
                permissions: '=',
                calls: '=',
                callbacks: '&',
                reference: '=',
            }
        });
    })(Holiday = QMC.Holiday || (QMC.Holiday = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Holiday/qmc.holiday.js.map
